import { DistributionsList } from "components";
import { PropTypes } from "prop-types";

const ReleaseDetailsDistributions = ({ releaseId }) => <DistributionsList releaseId={releaseId} />;

export default ReleaseDetailsDistributions;

ReleaseDetailsDistributions.propTypes = { releaseId: PropTypes.string };
